import React from "react";
import { Layers } from "lucide-react";
import { DocPickerGrid } from "@/components/learning/DocPickerGrid";
import { useTranslation } from "@/context/LanguageContext";

export default function StudyPicker() {
    const { t } = useTranslation();
    return (
        <div className="mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:py-10" data-testid="study-picker-page">
            <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[hsl(var(--primary))]/15 text-[hsl(var(--primary))]">
                    <Layers className="h-5 w-5" />
                </div>
                <div>
                    <h1 className="font-sans-display text-2xl font-semibold tracking-tight text-t1 sm:text-3xl">{t("docpicker.study.title")}</h1>
                    <p className="mt-1 text-t3">{t("docpicker.study.subtitle")}</p>
                </div>
            </div>
            <div className="mt-8">
                <DocPickerGrid mode="study" />
            </div>
        </div>
    );
}
